import React, {useState, useEffect} from "react";
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";
import results from "../../components/APILibrary/results.json";
import LibraryCard from "../../components/APILibrary/LibraryCard";
import { useIsAuthenticated } from "@azure/msal-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTag, faKey, faSearch, faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Select, { components } from 'react-select';
import "./APILibrary.css"
import { useMediaQuery } from 'react-responsive';
import { scrollToTop } from "../../helpers/scrollUtil";

const APILibrary = () => {
  const [searchVal, setSearchVal] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [numberOfResultsTotal, setNumberOfResultsTotal] = useState(0);
  const [numberOfResultsFiltered, setNumberOfResultsFiltered] = useState(0);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedAuthTypes, setSelectedAuthTypes] = useState([]);
  const [toggleMobileFilters, setToggleMobileFilters] = useState(false);
  const [topics, setTopics] = useState([]);
  const [authTypes, setAuthTypes] = useState([]);
  const showMobileFilter = useMediaQuery({ maxWidth: 930 });
  const smallScreens = useMediaQuery({ maxWidth: 640 });
  const isAuthenticated = useIsAuthenticated();
  // const breadcrumbs = [{ name: "Home", link: "/" }, { name: "API Library" }];

  useEffect(() => {
    scrollToTop();
  },[])

  useEffect(() => {
    const trimmedSearchVal = searchVal.trim().toLowerCase();
    let tempResults = results;
    let tempResultCount = results.length;

    tempResults = getApis(tempResults, trimmedSearchVal, selectedTopics, selectedAuthTypes);
    setNumberOfResultsTotal(tempResultCount);
    
    tempResults.sort((a, b) => a.name.localeCompare(b.name));
    setFilteredResults(tempResults);
    setNumberOfResultsFiltered(tempResults.length)
    getTopicsAndAuthTypes(results, setTopics, setAuthTypes, parseAuthType, parseTopic);
  }, [searchVal, isAuthenticated, selectedAuthTypes, selectedTopics]);

  const handleSearchInputChange = (event) => {
    setSearchVal(event.target.value);
  };

  const getTopicsAndAuthTypes = (results, setTopics, setAuthTypes, parseAuthType, parseTopic) => {
    let topicSet = new Set();
    let authTypeSet = new Set();
    results.forEach(item => {
      item.topics?.forEach(topic => topicSet.add(topic));
      item.authTypes?.forEach(authType => authTypeSet.add(authType));
    });

    const topicsArray = Array.from(topicSet).map(topic => ({
      value: topic,
      label: parseTopic(topic)
    }));
    
    const authTypesArray = Array.from(authTypeSet).map(authType => ({
      value: authType,
      label: parseAuthType(authType)
    }));

    setAuthTypes(authTypesArray);
    setTopics(topicsArray);
  }

  const renderMobileFilter = () => {
    if (showMobileFilter) {
      if (toggleMobileFilters) {
        return (
          <div className="sticky-filter-button" onClick={() => toggleMobileFiltersFunc()}>
            <div>
              Hide Filters
            </div>
            <div>
              <FontAwesomeIcon icon={faMinus} />
            </div>
          </div>
        )
      } else {
        return (
          <div className="sticky-filter-button" onClick={() => toggleMobileFiltersFunc()}>
            <div>
              Show Filters
            </div>
            <div>
              <FontAwesomeIcon icon={faPlus}/>
            </div>
          </div>
        )
      }
    }
  }

  const getApis = (tempApis, search, selectedTopics, selectedAuthTypes) => {
    const extractTopics = selectedTopics.map(topic => topic.value);
    const extractAuthTypes = selectedAuthTypes.map(auth => auth.value);
  
    return tempApis.filter((result) => {
      const matchesSearch = search
        ? (
            result.name.toLowerCase().includes(search.toLowerCase()) ||
            result.description.toLowerCase().includes(search.toLowerCase()) ||
            result.availability.toLowerCase().includes(search.toLowerCase())
          )
        : true;
  
      const matchesTopics = extractTopics.length > 0
        ? result.topics.some(topic => extractTopics.includes(topic))
        : true;
  
      const matchesAuth = extractAuthTypes.length > 0
        ? result.authTypes.some(auth => extractAuthTypes.includes(auth))
        : true;

      return matchesSearch && matchesTopics && matchesAuth;
    });
  };

  const CustomValueContainer = (props) => {
    const { children, selectProps } = props;
    const iconToDisplay = selectProps.icon;
  
    return (
      <components.ValueContainer {...props}>
        <div className="input-tags">
          {iconToDisplay && (
            <FontAwesomeIcon aria-hidden="false" aria-label="dropdown-arrow" icon={iconToDisplay} style={{ marginRight: '8px', color: '#999' }} />
          )}
          {children}
        </div>
      </components.ValueContainer>
    );
  };
  
  const toggleMobileFiltersFunc = () => {
    setToggleMobileFilters(!toggleMobileFilters);
  }

  const parseAuthType = (authType) => {
    if (!authType) return '';
    const result = authType
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (char) => char.toUpperCase());

    if (result === 'Sams Credentials') {
      return 'SAMS Credentials';
    } else {
      return result;
    }
  }

  const parseTopic = (topic) => {
    if (!topic) return '';
    const result = topic.toUpperCase();

    if (result === 'CDCONLY') {
      return 'CDC Only';
    } else {
      return result;
    }
  }

  return (
    <main>
      <PrimaryNav />
      {/* <Breadcrumbs crumbs={breadcrumbs} /> */}
      <div className="container-pad phone">
        <div>
            <h1 className="patua-one-regular fs-40 mb-0">Explore Our API Library</h1>
            <p className="patua-one-regular fs-20">View and sort our APIs to find the best one for your needs.</p>
            <div className="flex-sb">
              {
                !showMobileFilter && 
                <div className="w-70p">
                  <div style={{ display: 'flex', gap: '20px', alignItems: 'center',padding: '10px'}}>
                    <Select
                      aria-label="Select Topic"
                      isMulti
                      defaultValue={selectedTopics.map(topic => topic)}
                      onChange={setSelectedTopics}
                      options={[...topics].sort((a, b) => a.label.localeCompare(b.label))}
                      placeholder="Topic..."
                      styles={{
                          placeholder: (provided) => ({
                          ...provided,
                          color: '#757575',
                        })
                      }}
                      className="rs-custom"
                      components={{ ValueContainer: CustomValueContainer }}
                      icon={faTag}
                      aria-labelledby="select-topic-label"
                    />
                    <Select
                      aria-label="Select Auth Type"
                      isMulti
                      defaultValue={selectedAuthTypes.map(auth => auth)}
                      onChange={setSelectedAuthTypes}
                      options={[...authTypes].sort((a, b) => a.label.localeCompare(b.label))}
                      placeholder="Auth Type..."
                      styles={{
                          placeholder: (provided) => ({
                          ...provided,
                          color: '#757575',
                        })
                      }}
                      className="rs-custom"
                      components={{ ValueContainer: CustomValueContainer }}
                      icon={faKey}
                      aria-labelledby="select-auth-type-label"
                    />
                    <form className="usa-search rs-custom" role="search">
                      <label className="usa-sr-only" for="search-field">Search</label>
                      <input className="usa-input custom-search mt-0" id="search-field" name="search" value={searchVal} placeholder="Search for keyword" onChange={handleSearchInputChange}/>
                      <div aria-hidden="false" className="usa-button h-38" type="submit" onClick={(e) => e.preventDefault()}>
                        <FontAwesomeIcon icon={faSearch} />
                      </div>
                    </form>
                  </div>
                </div>
              }
              {
                (toggleMobileFilters && !smallScreens && showMobileFilter) &&
                <div className="fixed-search">
                  <div style={{ display: 'flex', gap: '20px', alignItems: 'center',padding: '10px'}}>
                    <Select
                      isMulti
                      defaultValue={selectedTopics.map(topic => topic)}
                      onChange={setSelectedTopics}
                      options={[...topics].sort((a, b) => a.label.localeCompare(b.label))}
                      placeholder="Topic..."
                      className="rs-custom"
                      components={{ ValueContainer: CustomValueContainer }}
                      icon={faTag}
                    />
                    <Select
                      isMulti
                      defaultValue={selectedAuthTypes.map(auth => auth)}
                      onChange={setSelectedAuthTypes}
                      options={[...authTypes].sort((a, b) => a.label.localeCompare(b.label))}
                      placeholder="Auth Type..."
                      className="rs-custom"
                      components={{ ValueContainer: CustomValueContainer }}
                      icon={faKey}
                    />
                      <form className="usa-search rs-custom" role="search">
                        <label className="usa-sr-only" for="search-field">Search</label>
                        <input className="usa-input custom-search mt-0" id="search-field" name="search" value={searchVal} placeholder="Search for keyword" onChange={handleSearchInputChange}/>
                        <button className="usa-button h-38" type="submit" onClick={(e) => e.preventDefault()}>
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
              }
                            {
                (toggleMobileFilters && smallScreens) &&
                <div className="fixed-search">
                  <div style={{ padding: '10px'}}>
                    <Select
                      isMulti
                      defaultValue={selectedTopics.map(topic => topic)}
                      onChange={setSelectedTopics}
                      options={[...topics].sort((a, b) => a.label.localeCompare(b.label))}
                      placeholder="Topic..."
                      className="rs-custom"
                      components={{ ValueContainer: CustomValueContainer }}
                      icon={faTag}
                    />
                    <Select
                      isMulti
                      defaultValue={selectedAuthTypes.map(auth => auth)}
                      onChange={setSelectedAuthTypes}
                      options={[...authTypes].sort((a, b) => a.label.localeCompare(b.label))}
                      placeholder="Auth Type..."
                      className="rs-custom mt-10"
                      components={{ ValueContainer: CustomValueContainer }}
                      icon={faKey}
                    />
                      <form className="usa-search rs-custom mt-10" role="search">
                        <label className="usa-sr-only" for="search-field">Search</label>
                        <input className="usa-input custom-search mt-0" id="search-field" name="search" value={searchVal} placeholder="Search for keyword" onChange={handleSearchInputChange}/>
                        <button className="usa-button h-38" type="submit" onClick={(e) => e.preventDefault()}>
                          <FontAwesomeIcon icon={faSearch} />
                        </button>
                      </form>
                    </div>
                  </div>
              }
              <div className="library-results no-bold patua-one-regular">
                Showing <b className="fw-400">{numberOfResultsFiltered}</b> of <b className="fw-400">{numberOfResultsTotal}</b> APIs
              </div>
            </div>
        </div>

        <div className="cards-grid">
          {filteredResults.length > 0 ? (
            filteredResults.map((result, index) => (
              <div>
                <LibraryCard key={index} api={result} searchVal={searchVal}/>
                <hr/>
              </div>
            ))
          ) : (
            <div className="no-results">No APIs match your search. Try a different keyword.</div>
          )}
        </div>
        { filteredResults.length > 0 && <div className="flex-center italic pad-10">End of list</div>}
        {renderMobileFilter()}
      </div>
    </main>
  );
};

export default APILibrary;